import React from "react";
import {Button as BootstrapButton} from "react-bootstrap";

type Props = {
    variant?:
        "primary" |
        "secondary" |
        "success" |
        "danger" |
        "warning" |
        "info" |
        "dark" |
        "light" |
        "link";
    outline?: boolean;
    size?:
        "sm" |
        "lg";
    disabled?: boolean;
    type?:
        "button" |
        "reset" |
        "submit";
    children: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const Button = (props: Props) => {
    const {variant = "primary", outline = false, size, disabled, type = "button", children, onClick} = props;

    return (
        <BootstrapButton
            variant={outline ? `outline-${variant}` : variant}
            size={size}
            disabled={disabled}
            type={type}
            onClick={onClick}
        >
            {children}
        </BootstrapButton>
    );
};

export default Button;